<div class="menubar header-color">
  <div class="menu-container">
    <div (click)="resetWarning(); goToDashboard();" [pTooltip]="'Home'" class="main-logo pointer">
    </div>
    @if (parentShowBurger) {
      <i (click)="openCloseNav()" class="pi pi-bars hamburger"></i>
    }
    <div class="right-dropdown">
      @if (isAdministrator) {
        @if(isMobile) {
          <i class="fa fa-magnifying-glass header-search" (click)="showMobileSearch = !showMobileSearch"></i>
        }
        @if(!isMobile) {
          <div class="search-container margin-top-5">
            <div #autocompleteDiv class="p-inputgroup w-full md:w-30rem">
              <p-autoComplete (completeMethod)="searchMembers($event)" (onSelect)="getMember(selectedMember)" [(ngModel)]="selectedMember" [placeholder]="placeholder"
                              [suggestions]="suggestions" autocomplete="false" data-lpignore="true" inputStyleClass="keeper-ignore" pTooltip="Search Phone Number by entering a + before the number" tooltipPosition="left"
                              keeper-ignore optionLabel="Name" tooltipStyleClass="w-60!">
                <ng-template let-member pTemplate="item">

                  <div>{{ member.Name }} - {{ member.OrgAbbrev }} - {{ member.PrimaryEmailAddress }}</div>

                </ng-template>
              </p-autoComplete>
              @if (searching) {
                <span class="p-inputgroup-addon pointer"><span class="fa fa-spinner search-spinner"></span></span>
              }
              <!--            <span class="p-inputgroup-addon pointer" (click)="toggleSearch();">{{ buttonIcon }}</span>-->
              <span class="p-inputgroup-addon pointer"><i (click)="selectedMember = null" class="fas fa-times"></i></span>
            </div>
          </div>
        }
      }

      @if (showMenuSelect) {
        <i (click)="menuSelected()" class="fas fa-ellipsis-h"></i>
      }
      @if (isSuperUser) {
        <i (click)="openDataPerspective($event); menuOpen = false; alertsOpen = false;" class="fas fa-eye eye"></i>
      }
      @if (dataPerspectiveOpen) {
        <div class="dataperspective-content">
          <app-data-perspective-dropdown (showDropDown)="ShowDropDown()"></app-data-perspective-dropdown>
          <div class="p-fluid p-grid">
            @if (showWorkingAs) {
              <div class="col-md-12 col-sm-12 col-xs-12">
                <label>Working As:</label>
                <p-select (onChange)="processClient($event)" [(ngModel)]="selectedWorkingAs" [class]="'working-as-dropdown'"
                          [options]="options"
                          optionLabel="description" optionValue="description"></p-select>
              </div>
            }
          </div>
        </div>
      }
      @if (isSuperUser) {
        <i (click)="toggleAlertMenu(); menuOpen = false; dataPerspectiveOpen = false;" [value]="alertCount.toString()" class="fas fa-bell alert-bell"
           pBadge></i>
      }
      @if (personPhotoSrc) {
        <img (click)="toggleMenu($event); alertsOpen = false; dataPerspectiveOpen = false;" [priority]="true" alt="" class="profile-img" height="34"
             ngSrc="{{personPhotoSrc}}" width="34"/>
      }
      @if (menuOpen) {
        <div class="dropdown-content">
          <div class="menu-link" routerLink="profile"><i class="fas fa-user"></i> My Profile</div>
          <div class="menu-link settings" routerLink="settings"><i class="fas fa-user-cog"></i> Settings & Security
          </div>
          <!--          for later bk-->
<!--          <div (click)="contactSupport()" class="menu-link settings"><i class="fas fa-user-headset"></i> Contact Support</div>-->
          <div (click)="logOut()" class="menu-link profile-btn"><i class="pi pi-power-off"></i> Log Out</div>
          <div class="divider-line"></div>
          <div class="mb-10">Welcome back, {{ personName }}.</div>
          <div class="mb-10">(Logged in since {{ loggedIn }})</div>
          <div class="divider-line"></div>
        </div>
      }
    </div>
  </div>
  <div class="toast-container">
    <p-toast [baseZIndex]="200000" position="top-center"></p-toast>
    <p-toast [baseZIndex]="1600000" class="html-toast" key="innerHTML" life="200000" position="top-center">
      <ng-template let-message pTemplate="message">
        <p innerHtml="{{message.detail}}"></p>
      </ng-template>
    </p-toast>
  </div>
  @if(isMobile && showMobileSearch) {
    <div class="mobile-search-bar ">
      <div #autocompleteDiv class="p-inputgroup w-full md:w-30rem">
        <p-autoComplete (completeMethod)="searchMembers($event)" (onSelect)="getMember(selectedMember); showMobileSearch = false" [(ngModel)]="selectedMember" [placeholder]="placeholder"
                        [suggestions]="suggestions" autocomplete="false" data-lpignore="true" inputStyleClass="keeper-ignore">
          <ng-template let-member pTemplate="item">

            <div>{{ member.Name }} - {{ member.OrgAbbrev }} - {{ member.PrimaryEmailAddress }}</div>

          </ng-template>
        </p-autoComplete>
        @if (searching) {
          <span class="p-inputgroup-addon pointer"><span class="fa fa-spinner search-spinner"></span></span>
        }
        <!--            <span class="p-inputgroup-addon pointer" (click)="toggleSearch();">{{ buttonIcon }}</span>-->
        <span class="p-inputgroup-addon pointer"><i (click)="selectedMember = null" class="fas fa-times"></i></span>
      </div>
    </div>
  }
</div>
